"use client";

import { ArrowRight, Expand, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurBase() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contactRef,
    isVisible: contactVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: zonesRef,
    isVisible: zonesVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const socials = [{
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "LinkedIn",
    icon: Linkedin,
    href: "#"
  }, {
    name: "YouTube",
    icon: Youtube,
    href: "#"
  }];
  const zones = ["NEW YORK", "LOS ANGELES", "MIAMI", "LONDON"];
  return <section data-section-id="2708" id="our-base" className="bg-background text-foreground py-20 md:py-32 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {}
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-8">
            <div className="h-px w-12 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              CONNECT 
            </span>
          </div>

          <h2 className="font-default font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-[0.9] tracking-tight mb-6">
            VIVID{" "}
            <span className="inline-block" style={{
            WebkitTextStroke: "1.5px currentColor",
            color: "transparent"
          }}>
              STUDIO
            </span>
          </h2>

          <p className="font-mono text-xs sm:text-sm uppercase tracking-widest text-muted-foreground">
            CREATIVE PRODUCTION HQ 
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
          {}
          <div ref={contactRef} className={`lg:col-span-5 flex flex-col gap-12 transition-all duration-700 ease-out delay-100 ${contactVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`}>
            {}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-chart-1">
                  [01]
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                  LOCATION
                </span>
              </div>
              <p className="font-default text-2xl md:text-[1.5rem] leading-tight tracking-tight">
                88 Creative Plaza,
                <br />
                Design District, NY 10012
              </p>
            </div>

            <Separator className="bg-border/60" />

            {}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-chart-1">
                  [02]
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                  DIRECT
                </span>
              </div>

              <div className="space-y-5">
                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground w-16 shrink-0">
                    TEL 
                  </span>
                  <Link to="tel:+12125550199" className="font-default text-lg md:text-xl text-foreground hover:text-primary transition-colors">
                    (212) 555-0199
                  </Link>
                </div>

                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground w-16 shrink-0">
                    MAIL 
                  </span>
                  <Link to="mailto:hello@vividstudio.com" className="font-default text-lg md:text-xl text-foreground hover:text-primary transition-colors break-all">
                    hello@vividstudio.com
                  </Link>
                </div>

                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground w-16 shrink-0">
                    HRS 
                  </span>
                  <div className="font-default text-base md:text-lg text-foreground space-y-1">
                    <div>Mon–Fri: 9am – 7pm</div>
                    <div className="text-muted-foreground">Sat–Sun: By Appointment</div>
                  </div>
                </div>
              </div>
            </div>

            <Separator className="bg-border/60" />

            {}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-chart-1">
                  [03]
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                  SOCIALS
                </span>
              </div>
              <div className="flex items-center gap-3">
                {socials.map((social, i) => {
                const Icon = social.icon;
                return <Link key={social.name} to={social.href} data-index={i} aria-label={social.name} className="w-11 h-11 inline-flex items-center justify-center border border-border/60 hover:border-primary hover:text-primary text-foreground transition-all rounded-md">
                      <Icon className="w-4 h-4" />
                    </Link>;
              })}
              </div>
            </div>

            {}
            <div className="pt-2">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-6 font-mono text-xs uppercase tracking-widest rounded-md shadow-md group">
                <Link to="/StartProjectPage">
                  DOWNLOAD CAPABILITIES
                  <ArrowRight className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={mapRef} className={`lg:col-span-7 transition-all duration-700 ease-out delay-200 ${mapVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`}>
            <div className="relative">
              {}
              <div className="absolute -top-6 left-0 font-mono text-[10px] uppercase tracking-widest text-chart-1 z-10">
                LAT: 40.7242° N
              </div>
              <div className="absolute -top-6 right-0 font-mono text-[10px] uppercase tracking-widest text-chart-1 z-10">
                LONG: 73.9965° W
              </div>

              {}
              <div className="relative w-full h-[500px] md:h-[600px] border border-foreground/10 rounded-md overflow-hidden bg-card">
                {}
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701998/img/vivid_studio_map.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701998/img/vivid_studio_map.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701998/img/vivid_studio_map.webp-wvc-sizes" alt="Vivid Studio location map" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-80" />

                {}
                <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
                backgroundImage: "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
                backgroundSize: "40px 40px"
              }} />

                {}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="relative flex items-center justify-center">
                    {}
                    <span className="absolute inline-flex w-16 h-16 rounded-md bg-primary/30 animate-ping" style={{
                    animationDuration: "2.5s"
                  }} />
                    <span className="absolute inline-flex w-10 h-10 rounded-md bg-primary/40 animate-ping" style={{
                    animationDuration: "2s",
                    animationDelay: "0.3s"
                  }} />
                    {}
                    <span className="relative inline-flex w-4 h-4 rounded-md bg-primary shadow-lg shadow-primary/50 ring-2 ring-primary/30" />
                  </div>
                </div>

                {}
                <Link to="#" className="absolute top-4 right-4 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-foreground bg-background/70 backdrop-blur-sm border border-foreground/10 px-3 py-2 hover:border-primary hover:text-primary transition-colors rounded-md">
                  EXPAND MAP
                  <Expand className="w-3 h-3" />
                </Link>

                {}
                <div className="absolute bottom-4 left-4 bg-background/70 backdrop-blur-sm border border-foreground/10 px-3 py-2 rounded-md">
                  <div className="font-mono text-[9px] uppercase tracking-widest text-muted-foreground mb-0.5">
                    VIVID 
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-foreground">
                    STUDIO HQ
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -bottom-6 left-0 font-mono text-[10px] uppercase tracking-widest text-chart-1">
                NODE 01 / PRODUCTION
              </div>
              <div className="absolute -bottom-6 right-0 font-mono text-[10px] uppercase tracking-widest text-chart-1">
                VER: 2.0
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 mb-10">
          <Separator className="bg-border/60" />
        </div>

        {}
        <div ref={zonesRef} className={`transition-all duration-700 ease-out ${zonesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-chart-1 shrink-0">
              GLOBAL REACH 
            </span>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 font-mono text-xs sm:text-sm uppercase tracking-widest text-foreground">
              {zones.map((zone, i) => <div key={zone} data-index={i} className="flex items-center gap-4">
                  <span className="hover:text-primary transition-colors">{zone}</span>
                  {i < zones.length - 1 && <span className="text-muted-foreground/40">/</span>}
                </div>)}
              <span className="text-muted-foreground/40 hidden md:inline">—</span>
              <span className="text-muted-foreground">EXPANDING 2026</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}